module.exports = __webpack_public_path__ + "img/grc.c49461c7.svg";